module.exports = __webpack_public_path__ + "static/media/semanaCiencia.9ebb4c1d.webp";